import React from "react";
import InteractiveDots from "@/components/layout/InteractiveDots";
import PlatformShowcase from "@/components/layout/PlatformShowcase";
import CTAButton from "@/components/ui/CTAButton";
import { COLORS, FONTS, LAYOUT } from "@/constants/theme";

/**
 * Sección Hero. Copy tomado del one-pager institucional de ALTAMA.
 *
 * @returns {JSX.Element}
 */
const HeroSection = () => {
  return (
    <section
      className="relative overflow-hidden px-6 pb-16 pt-28 sm:pb-24 sm:pt-36 md:pb-32 md:pt-44"
      id="inicio"
      style={{
        backgroundColor: COLORS.bgPrimary,
        scrollMarginTop: LAYOUT.scrollOffset,
        backgroundImage: `linear-gradient(180deg, ${COLORS.bgPrimary} 0%, ${COLORS.bgSecondary} 100%)`,
      }}
    >
      {/* Malla de puntos que reacciona al cursor y deja estela. */}
      <InteractiveDots />

      {/* Difuminado de los bordes para que la malla no se corte de golpe. */}
      <div
        aria-hidden="true"
        className="pointer-events-none absolute inset-0"
        style={{
          background: `radial-gradient(ellipse at 50% 45%, transparent 45%, ${COLORS.bgPrimary} 100%)`,
          opacity: 0.55,
        }}
      />

      {/* -- Hero -- */}
      <div className="relative mx-auto" style={{ maxWidth: LAYOUT.maxWidth }}>
        <div className="grid grid-cols-1 items-center gap-10 sm:gap-14 lg:grid-cols-12 lg:gap-10">
          <div className="lg:col-span-6">
            <p
              className="mb-7 text-[0.72rem] uppercase md:text-[0.78rem]"
              style={{
                color: COLORS.textSecondary,
                fontFamily: FONTS.data,
                letterSpacing: "0.18em",
              }}
            >
              Estrategia · Datos · Econometría · Decisión
            </p>

            <h1
              className="text-[2.7rem] md:text-[3.9rem]"
              style={{
                color: COLORS.textPrimary,
                fontFamily: FONTS.display,
                lineHeight: 1.05,
                fontWeight: 600,
                letterSpacing: "-0.018em",
                maxWidth: "14ch",
              }}
            >
              Transformamos datos en decisiones.
            </h1>

            {/* Regla naranja: viene del one-pager institucional. */}
            <div
              aria-hidden="true"
              className="mt-7"
              style={{ width: "64px", height: "3px", backgroundColor: COLORS.webOrange }}
            />

            <p
              className="mt-7 text-[1.06rem] md:text-[1.12rem]"
              style={{
                color: COLORS.textSecondary,
                fontFamily: FONTS.body,
                lineHeight: 1.75,
                maxWidth: "52ch",
              }}
            >
              Consultoría especializada en analítica de datos, econometría y soluciones empresariales para reducir
              incertidumbre y tomar mejores decisiones.
            </p>

            <div className="mt-9 flex flex-col items-stretch gap-3 sm:flex-row sm:items-start">
              <CTAButton href="#contacto">Agendar una reunión</CTAButton>
              <CTAButton href="#servicios" variant="outline">
                Ver capacidades
              </CTAButton>
            </div>
          </div>

          <div className="lg:col-span-6">
            <PlatformShowcase />
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
